import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-twitter',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="m3 21 7.5484-7.5484M21 3l-7.5484 7.5484m0 0L8 3H3l7.5484 10.4516m2.9032-2.9032L21 21h-5l-5.4516-7.5484" />
    </svg>
  `
})
export class IconTwitterComponent {
  size: InputSignal<number> = input<number>(24);
}
